<template>
  <div class="contract-list">
    <div>
      <el-row class="filter-wrap" :gutter="20">
        <el-col :span="4">
          <el-input clearable v-model="form.nameOrCode" size="small" placeholder="框架合同名称/编号" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input clearable v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input clearable v-model="form.principalName" size="small" placeholder="有花果对接负责人" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input clearable v-model="form.sealApplyUserName" size="small" placeholder="盖章申请人" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-wrap">
      <el-row class="table-count-wrap" :gutter="20">
        <el-col :span="10">
          <p class="table-count">
            <span>框架合同总数：{{ total }}条</span>
          </p>
        </el-col>
      </el-row>
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="框架合同信息" prop="code" align="center">
          <template slot-scope="scope">
            <div>{{scope.row.name}}</div>
            <div>{{scope.row.code}}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="客户类型" prop="customerType" align="center">
          <template slot-scope="scope">
            {{scope.row.customerType=='1'?'品牌方':scope.row.customerType=='2'?'Agency':''}}
          </template>
        </el-table-column>
        <el-table-column label="合同状态" prop="status" align="center">
          <template slot-scope="scope">
            {{scope.row.status=='1'?'洽谈中':scope.row.status=='2'?'已签约':''}}
          </template>
        </el-table-column>
        <el-table-column label="对接负责人" prop="principalName" align="center"></el-table-column>
        <el-table-column label="框架协议文件" prop="businessPrincipal" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.fileList">
              <div v-if="scope.row.fileList.length>0">
                <filePreview :fileList="scope.row.fileList"></filePreview>
              </div>
            </div>
            <div v-else style="color:#CCC;font-size:12px;">暂无框架协议文件</div>
          </template>
        </el-table-column>
        <el-table-column label="盖章申请人" prop="sealApplyUserName" align="center">
          <template slot-scope="scope">
            {{scope.row.sealApplyUserName || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="盖章申请时间" prop="sealApplyTime" align="center">
          <template slot-scope="scope">
            {{scope.row.sealApplyTime || '--'}}
          </template>
        </el-table-column>
        <el-table-column v-if="type==='ExamineProcessing'" label="审核状态" prop="auditStatus" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.auditStatus">{{approveConfig.getAppointed("status", scope.row.auditStatus, "")}}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column v-else label="盖章状态" prop="sealStatus" align="center">
          <template slot-scope="scope">
            {{sealStatus[scope.row.sealStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type==='ExamineProcessing'" type="text" size="small" @click="toAssess(scope.row.id,1)">审批</el-button>
            <el-button v-else type="text" size="small" @click="toAssess(scope.row.id,2)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="form.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
  </div>
</template>

<script>
import { approveConfig } from "@/const/config/approve";
import { frameworkAgreementList, } from "../api";
export default {
  props: ["type"],
  components: {
  },
  data() {
    return {
      approveConfig,
      sealStatus:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
      //调整监测时间规则
      form: {
        auditFlag:0,
        customerName:"",
        nameOrCode:"",
        principalName:"",
        sealApplyUserName:"",
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      object:'',
      tableData: [],
      tableLoading: false,
    };
  },
  mounted() {
    if(this.type ==='ExamineProcessing'){
      this.form.auditFlag = 0
    }else{
      this.form.auditFlag = 1
    }
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.form.pageNum = 1;
      this.form.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.form.pageNum = val;
      this.getList();
    },
    // 搜索
    onSearch() {
      this.form.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      this.tableLoading = true;
      frameworkAgreementList(this.form).then((res) => {
        console.log('====获取列表====',res)
        if(res.code === 1){
          this.tableData = res.data;
          this.total = res.total;
        }
        this.tableLoading = false;
      })
    },
    /**
     * 跳转到审批页
     */
    toAssess(id,type) {
      let router = this.$router.push({
        path: "/check/sealed/assess",
        query: {id,type},
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
  },
};
</script>

<style lang="scss" scoped>
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  span {
    margin-right: 20px;
  }
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    min-height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
// 弹出框body
/deep/.el-dialog__body {
  padding-top: 0 !important;
  .mb-10 {
    margin-bottom: 10px;
  }
}
</style>